<template>
  <nav
    :class="{ 'navbar-dark bg-dark': env === 'production' }"
    class="navbar"
  >
    <router-link
      class="navbar-brand"
      to="/"
    >
      Traffic Admin {{ env }}
    </router-link>
    <ul class="navbar-nav">
      <auth-link
        tag="li"
        class="nav-item"
        to="/brands"
        active-class="active"
        permission="brand-index"
      >
        <a class="nav-link">Brands &amp; websites</a>
      </auth-link>
    </ul>
    <ul class="navbar-nav">
      <auth-link
        tag="li"
        class="nav-item"
        to="/languages"
        active-class="active"
        permission="language-index"
      >
        <a class="nav-link">Languages</a>
      </auth-link>
    </ul>
    <ul class="navbar-nav">
      <auth-link
        tag="li"
        class="nav-item"
        to="/users"
        active-class="active"
        permission="user-index"
      >
        <a class="nav-link">Users</a>
      </auth-link>
    </ul>
    <ul class="navbar-nav mr-auto">
      <auth-link
        tag="li"
        class="nav-item"
        to="/roles"
        active-class="active"
        permission="role-index"
      >
        <a class="nav-link">Roles</a>
      </auth-link>
    </ul>
    <ul class="navbar-nav">
      <li class="nav-item">
        <router-link
          class="nav-link"
          to="/users/change-password"
        >
          Change password
        </router-link>

        <router-link
          class="nav-link"
          to="/login"
          @click.native="logout"
        >
          Logout
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'NavbarMain',
  data () {
    return {
      env: process.env.NODE_ENV
    }
  },
  methods: {
    logout () {
      window.localStorage.clear()
    }
  }
}
</script>

<style lang="scss">
  @import "~@/assets/scss/_variables.scss";
  @import "~bootstrap/scss/mixins/breakpoints";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";
 .navbar{
   background: #5d5d5d;
   padding-left: 30px;
   padding-right: 30px;
   height: 66px;
   .navbar-nav{
    height: 100%;
     .nav-item {
      height: 100%;
      a {
        color: $white;
      }
      &.active{
        position: relative;
        &:before{
          position: absolute;
          content:'';
          bottom: -8px;
          left:50%;
          width: 50px;
          height: 5px;
          margin-left: -25px;
          background: $vue-blue;
        }
      }
     }
   }
     .navbar-nav:last-of-type .nav-item:last-of-type .nav-link {
      padding-right: 0;
    }
 }
</style>
